<template>
    <div class="Page">
        <Header></Header>
        <div class="MaxWid">
            123
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
import Header from '@/components/header/head';
import Footer from '@/components/header/footer';
import Banner from '@/components/banner/Banner';
import updateRegistration from '@/components/updateRegistration/DoingExercises.vue';
import userExercises from '@/components/updateRegistration/userExercises.vue';
export default {
    components: { Header, Footer, Banner, updateRegistration,userExercises },
    data() {
        return {
            typeId: null,
            id: null,
        }
    },
    created() {
        this.id = this.$route.query.id;
    },
    mounted() {
        //获取query参数
        console.log(this.$route.query.id);
        this.typeId = this.$route.query.typeId;
        
    },
    methods: {

    },
}
</script>
<style scoped>
.Page {
    background: #fff;
}

.MaxWid {
    max-width: 1180px;
    padding: 0 10px;
    margin: 0 auto;
}
</style>